module.exports = __webpack_public_path__ + "img/support.5d023ec2.png";